import { render, staticRenderFns } from "./WidgetProductions.vue?vue&type=template&id=6e997abb&"
import script from "./WidgetProductions.vue?vue&type=script&lang=js&"
export * from "./WidgetProductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e997abb')) {
      api.createRecord('6e997abb', component.options)
    } else {
      api.reload('6e997abb', component.options)
    }
    module.hot.accept("./WidgetProductions.vue?vue&type=template&id=6e997abb&", function () {
      api.rerender('6e997abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accueil/WidgetProductions.vue"
export default component.exports